<iframe [src]="url" height="100%" width="100%" allowfullscreen frameborder="0" title="Rules Author & Engine Viewer"></iframe>
